import { render, staticRenderFns } from "./PhoneVerify.vue?vue&type=template&id=5a24c0a1&scoped=true&"
import script from "./PhoneVerify.vue?vue&type=script&lang=ts&"
export * from "./PhoneVerify.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneVerify.vue?vue&type=style&index=0&id=5a24c0a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24c0a1",
  null
  
)

export default component.exports